export interface EnumListItem {
  label: string;
  value: string;
}

export interface MediaSelectionItem {
  name: string;
  id: number;
  udi: string;
  icon: string;
  trashed: boolean;
  key: string;
  parentId: number;
  alias: string;
  path: string;
  metaData: MediaSelectionMetaData;
  thumbnail: string;
  image: string;
  updateDate: string;
  filtered: boolean | null;
  $$hashKey: string;
  isFolder: boolean;
  width: number;
  height: number;
  aspectRatio: number;
  selectable: boolean;
  flexStyle: MediaSelectionFlexStyle;
  selected: boolean;
  altText?: string;
}

interface MediaSelectionMetaData {
  ContentTypeAlias: string;
  UpdateDate: string;
  MediaPath: string;
  IsContainer: boolean;
}

interface MediaSelectionFlexStyle {
  flex: string;
  'max-width': string;
  'min-width': string;
  'min-height': string;
}

export interface MediaPickerOutput {
  multiPicker: boolean;
  view: string;
  size: string;
  updatedMediaNodes: any[]; // TODO: Find out what this does contain
  infiniteMode: boolean;
  inFront: boolean;
  moveRight: boolean;
  level: number;
  styleIndex: number;
  animating: boolean;
  $$hashKey: string;
  selection: MediaSelectionItem[];
  title: string;
}

export interface LinkPickerOutPut {
  target: LinkPickerTarget;
}

export interface LinkPickerTarget {
  anchor: string;
  id: string;
  name: string;
  target: string;
  udi: string; // Umbraco reference
  url: string;
}

export const isImage = (url: string) => {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
};

export const isVideo = (url: string) => {
  return /\.(mp4|ogg|mov)$/.test(url);
};